var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('nav', {
    staticClass: "layout-footer footer",
    class: _vm.getLayoutFooterBg()
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col",
    staticStyle: {
      "margin-left": "0.5rem",
      "margin-top": "0.8rem"
    }
  }, [_c('span', {
    staticClass: "footer-text font-weight-bolder"
  }, [_vm._v(_vm._s(_vm.$t('tracking_systems_inc')) + " ")]), _vm._v("©\n      "), _c('span', {
    staticStyle: {
      "text-align": "center",
      "font-family": "sans-serif"
    }
  }, [_vm._v(_vm._s(_vm.year))])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }